import React, { Component } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";



class NewWindow extends Component {
    getStyles(autoSize, width, height,fitContent) {
        let modelStyle = {};
        if (fitContent) {
            const fitContentMinWidth = this.props.fitContentMinWidth || "min(720px, 90vw)";
            return {
                modal: {
                width: 'fit-content',       
                minWidth: fitContentMinWidth,
                maxWidth: '90vw',           
                height: 'fit-content',      
                maxHeight: '90vh',          
                overflow: 'auto',   
                borderRadius: '10px'        
                },
            };
            }

        if (autoSize)
            return modelStyle;

        
        // Need to validate widht and height input to be numbers
        const leftMargin = width ? ((100 - width) / 2) / 100 : 0.15;
        const actualWidth = width ? width / 100 : 0.7;
        const actualHeight = height ? height / 100 : 0.7;
        const smallestWidth = 400;
        let dialogWidth = window.innerWidth * actualWidth;
        let dialogLeftPosition = window.innerWidth * leftMargin;

        if (window.innerWidth <= smallestWidth) {
            dialogWidth = window.innerWidth * 0.9;
            dialogLeftPosition = window.innerWidth * 0.05;
        }

        const dimenstions = { width: dialogWidth, height: window.innerHeight * actualHeight };

        modelStyle = {
            modal: {
                width: dimenstions.width,
                maxWidth: 'initial',
                minHeight: dimenstions.height
            }
        };
        return modelStyle;
    }

    render() {
        const { autoSize,fitContent, customModalClass, widthPercentage, heightPercentage } = this.props;

        return (
            <Modal {...this.props} styles={this.getStyles(autoSize, widthPercentage, heightPercentage,fitContent)} center
                classNames={{
                    overlayAnimationIn: 'customEnterOverlayAnimation',
                    overlayAnimationOut: 'customLeaveOverlayAnimation',
                    modalAnimationIn: 'customEnterModalAnimation',
                    modalAnimationOut: 'customLeaveModalAnimation',
                    modal: customModalClass
                }}
                animationDuration={700}>
                <h3 className='new-window-title'>{this.props.title}</h3>
                <div className='new-window-body'>
                    {this.props.children}
                    </div>
            </Modal>);
  }
}

export default  NewWindow;
